/* eslint-disable jsx-a11y/label-has-associated-control */
import { Select } from '@kmx/legos-react-select';
import MigrationLink from '@shared/components/MigrationLink/MigrationLink';
import urlData, { buildLegacyLink, buildMfeLink } from '@shared/utilities/routes';
import { ChangeEvent, useRef, useState } from 'react';

import { findLocationContent } from '../../common/types';
import { getFindLocationContent } from '../../services/findlocation-service';
import { SectionContentProvider } from '../SectionContentProvider';

const placeHolder: findLocationContent = {} as findLocationContent;

const FindLocationBlock = (data: findLocationContent) => {
    const [selectedStateAbbreviation, setState] = useState('N/A');
    const findLocationRef = useRef(null);

    const isStateSelected =
        selectedStateAbbreviation.trim() !== '' &&
        selectedStateAbbreviation.trim().toUpperCase() !== 'N/A';
    const onLocationChange = (e: ChangeEvent<HTMLSelectElement>) => {
        setState(e.target.value);
        findLocationRef.current.querySelector('.find-location-button')?.focus();
    };

    const FindLocationButton = ({ children }) => {
        let config = urlData.locations;
        let options;
        if (isStateSelected) {
            config = urlData.locationState;
            options = { state: selectedStateAbbreviation };
        }
        const href = config.shouldUseMFE
            ? buildMfeLink(config.mfeLink, options)
            : buildLegacyLink(config.legacyLink, options);
        return (
            <hzn-button href={href} class="find-location-button m-t-l" variant="cta">
                {children}
            </hzn-button>
        );
    };

    return (
        <>
            <div className="mdc-layout-grid__cell--span-1-desktop show-desktop-flex" />
            <div
                ref={findLocationRef}
                className="mdc-layout-grid__cell--span-7-phone mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-desktop find-location-grid">
                <h4 className="kmx-typography--display-2 find-location-title m-b-m">
                    {data.BlockTitle}
                </h4>
                <p className="kmx-typography--body-1 find-location-body">{data.Description}</p>

                <div>
                    <Select
                        className="find-location-select m-b-l m-t-m"
                        onChange={onLocationChange}
                        id="state-location"
                        label=""
                        options={data.stateOptions}
                        value={selectedStateAbbreviation}
                    />
                </div>
                <FindLocationButton>
                    <label className="primary-1 find-location-button-label">FIND A LOCATION</label>
                </FindLocationButton>
                <p>
                    <MigrationLink config={urlData.locations} className={'find-location-link'}>
                        VIEW NATIONWIDE SCHEDULE
                    </MigrationLink>
                </p>
            </div>
            <div className="mdc-layout-grid__cell--span-1-desktop show-desktop-flex" />
            <div className="mdc-layout-grid__cell--span-5-phone mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-6-desktop find-location-hero">
                <img
                    className="find-location-hero-image"
                    alt=""
                    src={data.AuctionLocationHeroImageSrc}
                />
            </div>
        </>
    );
};

export default function FindLocation() {
    return (
        <>
            <section id="find-location">
                <div className="mdc-layout-grid__inner">
                    <SectionContentProvider get={getFindLocationContent} type="FindLocation">
                        <FindLocationBlock {...placeHolder} />
                    </SectionContentProvider>
                </div>
            </section>
        </>
    );
}
